/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * RumbleDirect API
 * OpenAPI spec version: 1.0.0
 */

export type RootCompanyResourceCompanyOutputJsonldType = typeof RootCompanyResourceCompanyOutputJsonldType[keyof typeof RootCompanyResourceCompanyOutputJsonldType];


export const RootCompanyResourceCompanyOutputJsonldType = {
  lease: 'lease',
  insurance: 'insurance',
  dealership: 'dealership',
  charging_provider: 'charging_provider',
  sharing_service: 'sharing_service',
} as const;
